import CustomIcon from "../image/CustomIcon";

function CustomCheckbox({ checked, onClick }) {
    return (
        <CustomIcon
            iconName={checked ? "checkbox_on" : "checkbox_off"}
            size={"24px"}
            onClick={onClick}
            cursor={"pointer"}
        />
    );
}

export default CustomCheckbox;
